import React from "react";
import { Col, Container, Row } from "reactstrap";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer mb-2">
        <Container fluid>
          <Row>
            <Col sm={6}>
              Global Yol Yardım © {new Date().getFullYear()} | 0 850 242 70 42 | info@globalyolyardim.com<br />
              <a
                href="https://globalassistance.com.tr/kvkk"
                target="_blank"
                style={{ textDecoration: "none", color: "#007bff" }}
              >
                Kişisel Verilerin Korunması Kanunu (KVKK)
              </a>{" "}
              |{" "}
              <a
                href="https://globalassistance.com.tr/mesafeli-satis-sozlesmesi"
                target="_blank"
                style={{ textDecoration: "none", color: "#007bff" }}
              >
                Mesafeli Satış Sözleşmesi
              </a>
            </Col>
            <Col sm={6}>
              <div className="text-sm-end d-none d-sm-block">
                Made with <i className="mdi mdi-heart text-danger"></i> by{" "}
                <a
                  href="https://kodexis.com/"
                  target="_blank"
                  style={{ textDecoration: "none", color: "#007bff" }}
                >
                  Kodexis
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
